import modalSubscribe from '@scripts/components/modal-subscribe'

const el = document.querySelector('.subscribe-container')

if (el) {
  modalSubscribe.init(el)
}
